/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.Chart";
        Widgets.DEFAULT_CHART_COLOURS = [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
        ];
        // Types we've coded reasonable support for - others may work but probably untested
        Widgets.SUPPORTED_CHART_TYPES = ['bar', 'doughnut', 'pie'];
        class ComponentChart extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._canvas = null;
                this._chart = null;
                this._currentRequest = null;
                this._readyToPlot = false;
                this._present = () => {
                    this._log.info("ComponentChart._present()");
                    this._canvas = document.createElement('canvas');
                    this._container.appendChild(this._canvas);
                    this._readyToPlot = true;
                    if (this._currentRequest)
                        this.drawChart(this._currentRequest);
                };
                this.drawChart = (chartConfig) => {
                    this._log.info("ComponentChart.drawChart()");
                    // May need to destroy old chart
                    if (this._chart != null) {
                        this._chart.destroy();
                        this._chart = null;
                    }
                    this._currentRequest = chartConfig;
                    if (!this._readyToPlot)
                        return;
                    // Throw out any more blatant errors
                    if (!chartConfig.hasOwnProperty('data') || !chartConfig.data)
                        return;
                    let data = chartConfig.data;
                    if (!data.hasOwnProperty('datasets') || !data.datasets || (data.datasets.length == 0))
                        return;
                    // Check for settings to default
                    this._defaultSeriesColours();
                    let context = this._canvas.getContext("2d");
                    this._chart = new Chart(context, this._currentRequest);
                };
                this._defaultSeriesColours = () => {
                    this._log.info("ComponentChart._defaultSeriesColours()");
                    this._currentRequest.data.datasets.forEach(dataset => {
                        // Because of the data type, we can't check for length, so assume >0 if it exists
                        if (!dataset.hasOwnProperty('backgroundColor') || !dataset.backgroundColor) {
                            dataset.backgroundColor = [];
                            for (let i = 0; i < dataset.data.length; i++) {
                                dataset.backgroundColor.push(Widgets.DEFAULT_CHART_COLOURS[i % Widgets.DEFAULT_CHART_COLOURS.length]);
                            }
                        }
                    });
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentChart::constructor");
                this._readyToPlot = false;
                this._config = config;
                this._readyToPresent = true;
                if (this._waitingToPresent)
                    this._present();
            }
        }
        Widgets.ComponentChart = ComponentChart;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
